/* eslint-disable react/prop-types */

import React from 'react';
import PropTypes from 'prop-types';

import NdsThemeProviderPurple from '@ntuctech/devex-tangram/Theme/NdsThemeProviderPurple';

import ErrorHandler from '../ErrorHandler';
import Auth0Provider from '../Auth0Provider';
import LayoutNew from '../theme/LayoutNew';

const Bootstrap = ({ children, ...rest }) => (
  <ErrorHandler>
    <Auth0Provider {...rest}>
      <NdsThemeProviderPurple>
        <LayoutNew>{children}</LayoutNew>
      </NdsThemeProviderPurple>
    </Auth0Provider>
  </ErrorHandler>
);

Bootstrap.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Bootstrap;
